import { render, staticRenderFns } from "./currentStatusCOD.vue?vue&type=template&id=6625cf82&"
import script from "./currentStatusCOD.vue?vue&type=script&lang=js&"
export * from "./currentStatusCOD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports